import logoImage from './../assets/images/providence-logo.png';
import FormHeader from "../components/providence/FormHeader";
import { getFormFields } from "../components/providence/fields";
import { CLIENT_NAME, CLIENT_THEME } from "../utils/constants";
import APP_ENV from "../config/appEnv";

const config = {
    clientName: CLIENT_NAME.PROVIDENCE,
    isMultiLingual: true,
    hideLanguageSwitcher: true,

    // theme
    theme: CLIENT_THEME.PROVIDENCE,

    // header
    logo: logoImage,
    logoHeight: 100,
    logoLink: APP_ENV.CLIENT_RETURN_URL,

    // entry form
    entryForm: {
        title: 'Providence Enrollee Advisory Committee Application',
        titleBg: 'secondary',
        customHeader: {
            enabled: true,
            component: FormHeader
        },
        customFields: {
            enabled: true,
            fieldGetter: getFormFields,
        },
        showReturn: false,
        showCancel: false,
        formSuccess: {
            message: 'Your response has been submitted.'
        }
    },

    // footer
    footer: {
        meta: {
            materialId: 'H9047_2025MK_PHA1391_C'
        },
    },
    tracking: {
        mail: "/?utm_source=mail&utm_medium=online&utm_campaign=recruit",
        mnews: "/?utm_source=mnews&utm_medium=online&utm_campaign=recruit",
        phcall: "/?utm_source=phcall&utm_medium=phone&utm_campaign=recruit",
        cs: "/?utm_source=cs&utm_medium=phone&utm_campaign=recruit",
        cm: "/?utm_source=cm&utm_medium=phone&utm_campaign=recruit",
        email: "/?utm_source=email&utm_medium=online&utm_campaign=recruit",
        pc: "/?utm_source=pc&utm_medium=online&utm_campaign=recruit",
        enews: "/?utm_source=enews&utm_medium=online&utm_campaign=recruit",
        sms: "/?utm_source=sms&utm_medium=phone&utm_campaign=recruit",
        lp: "/?utm_source=lp&utm_medium=online&utm_campaign=recruit",
    }
}

export default config;
